export default __webpack_public_path__ + "static/farmacorp-bfa73bb454a1c6b38eccbf47af9b1075.png";